const Cart = (props) => {
    return ( 
        <div>
            <div>
                <br /><br />
                <h4 id="cart" style={{fontFamily:"Monaco,monospace",color:"white",position:"relative",right:"-20px"}}><b id="cartmove">Your Cart</b></h4>
                <div>
                    <ul style={{position:"relative",right:"-30px",color:"white"}}>
                        <li id="chickenbiri" style={{display:"none"}}>
                           {props.name1}

                        </li>
                        
                        <li id="muttonbiri" style={{display:"none"}}>
                           {props.name2}
                        </li>
                        <li id="tikka" style={{display:"none"}}>
                            {props.name3} 
                        </li>
                        <li id="tandoori" style={{display:"none"}}>
                           {props.name4}
                        </li>
                        
                        <li id="mutton" style={{display:"none"}}>
                          {props.name5}
                          </li>
                          <li id="butter" style={{display:"none"}}>
                          {props.name6}
                        </li>
                        <li id="paneer" style={{display:"none"}}>
                            {props.name7}
                        </li>
                        <li id="chap" style={{display:"none"}}>
                            {props.name8}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
     );
}
 
export default Cart;
<div>
    
</div>